export const catalogActionTypes = {
  START_EXPORT_CATALOG_BY_ITEMS: "START_EXPORT_CATALOG_BY_ITEMS",
  EXPORT_CATALOG_BY_ITEMS_SUCCESS: "EXPORT_CATALOG_BY_ITEMS_SUCCESS",
  EXPORT_CATALOG_BY_ITEMS_FAILURE: "EXPORT_CATALOG_BY_ITEMS_FAILURE",

  START_EXPORT_CATALOG_BY_CATEGORIES: "START_EXPORT_CATALOG_BY_CATEGORIES",
  EXPORT_CATALOG_BY_CATEGORIES_SUCCESS: "EXPORT_CATALOG_BY_CATEGORIES_SUCCESS",
  EXPORT_CATALOG_BY_CATEGORIES_FAILURE: "EXPORT_CATALOG_BY_CATEGORIES_FAILURE",

  START_EXPORT_CATALOG_BY_ITEM_GROUPS: "START_EXPORT_CATALOG_BY_ITEM_GROUPS",
  EXPORT_CATALOG_BY_ITEM_GROUPS_SUCCESS: "EXPORT_CATALOG_BY_ITEM_GROUPS_SUCCESS",
  EXPORT_CATALOG_BY_ITEM_GROUPS_FAILURE: "EXPORT_CATALOG_BY_ITEM_GROUPS_FAILURE",
};

